module.exports = __webpack_public_path__ + "static/media/circle.5152ebc0.svg";